// 調整班表的員工篩選器，沒有選取任何人時代表顯示全部
import React from 'react';
import Select from 'react-select';
import { buildStaffOptions } from './util/staffFilterOptions';

function StaffFilterSelect({ inputId, staffList = [], value = [], onChange }) {
  const groups = buildStaffOptions(staffList);
  const selectedOptions = groups
    .reduce((all, group) => all.concat(group.options), [])
    .filter((option) => value.indexOf(option.value) !== -1);

  return (
    <Select
      inputId={inputId}
      options={groups}
      value={selectedOptions}
      isMulti
      isClearable
      isDisabled={groups.length === 0}
      className="basic-multi-select"
      classNamePrefix="staffFilter"
      placeholder="全部員工"
      noOptionsMessage={() => '查無員工'}
      // 父層 .overflow-x 會裁切選單，月曆的 z-index 也會蓋住它，所以掛到 body 上
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      onChange={(options) => onChange((options || []).map((option) => option.value))}
    />
  );
}

export default StaffFilterSelect;
